import { Link } from "react-router-dom";

const Privacy = () => {
  return (
    <div data-testid="privacy-page" className="pt-20">
      {/* Hero Section */}
      <section className="py-24 md:py-32 bg-cream">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-3xl">
            <p className="text-xs uppercase tracking-[0.3em] text-taupe mb-4">
              Legal
            </p>
            <h1 className="font-serif text-5xl md:text-6xl font-light tracking-tight leading-[0.9] text-matte">
              Privacy Policy
            </h1>
            <p className="mt-6 text-sm text-matte/50">
              Last updated: December 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 md:py-24 bg-smoke">
        <div className="container mx-auto px-4 md:px-8">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <div className="space-y-8">
              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Introduction</h2>
                <p className="text-matte/70 font-light leading-relaxed">
                  Medical Aesthetic Arts LLC ("we," "our," or "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website aestheticmedicalarts.online or use our services.
                </p>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Information We Collect</h2>
                <p className="text-matte/70 font-light leading-relaxed mb-4">
                  We may collect information about you in a variety of ways, including:
                </p>
                <ul className="list-disc pl-6 text-matte/70 font-light space-y-2">
                  <li>Personal Data: Name, email address, phone number, and mailing address</li>
                  <li>Health Information: Medical history and aesthetic treatment preferences</li>
                  <li>Payment Information: Credit card numbers and billing information</li>
                  <li>Usage Data: Information about how you use our website and services</li>
                </ul>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">How We Use Your Information</h2>
                <p className="text-matte/70 font-light leading-relaxed mb-4">
                  We use the information we collect to:
                </p>
                <ul className="list-disc pl-6 text-matte/70 font-light space-y-2">
                  <li>Provide, operate, and maintain our services</li>
                  <li>Process and complete transactions</li>
                  <li>Send you appointment reminders and confirmations</li>
                  <li>Respond to your inquiries and provide customer support</li>
                  <li>Send promotional communications (with your consent)</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              <div>
                <h2 className="font-serif text-2xl text-matte mb-4">Contact Us</h2>
                <p className="text-matte/70 font-light leading-relaxed">
                  If you have questions about this Privacy Policy, please contact us at:
                </p>
                <div className="mt-4 text-matte/70 font-light">
                  <p><strong>Medical Aesthetic Arts LLC</strong></p>
                  <p>Main Office: 3100 Smoketree Ct, Ste 800, Raleigh, NC 27604</p>
                  <p>Headquarters: 1950 Bluegrass Cir, Ste 360, Cheyenne, WY 82001</p>
                  <p>Phone: (844) 943-6191</p>
                  <p>Email: info@aestheticmedicalarts.online</p>
                  <p>Website: aestheticmedicalarts.online</p>
                </div>
              </div>
            </div>

            <div className="mt-12 pt-8 border-t border-matte/10">
              <Link to="/" className="btn-secondary">
                Return to Home
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
